// 查询
const CustomerListQuery = {
    layout:'inline',
    labelColProps: { span: 1 },
    wrapperColProps: { span: 3 },
    labelAlign:'right',
    labelColStyle:'0',
    formData:{},
    formField:[
        {
            // name:'customer.customerType', // 客户类型
            key:'type',
            type:'select',   
            allowClear:true,
            width:'180px',
            placeholder:'customer.customerType',
            optionToLocale:true,
            options:[
                {
                    label:'customer.user',
                    value:0,
                },
                {
                    label:'customer.dealer',
                    value:1
                },
                // {
                //     value:2,
                //     label:'order.ECommerceVendor',
                // },
                {
                    value:3,
                    label:'order.notForSale'
                },
            ]
        },
        {
            // name:'customer.customerName', // 客户联系人名称
            key:'name',
            type:'select',   
            allowClear:true,
            width:'250px',
            placeholder:'customer.contactName',
            options:[],
        },
        {
            // name:'order.orderSource', // 订单来源
            key:'source',
            type:'select',   
            allowClear:true,
            width:'250px',
            placeholder:'order.orderSource',
            options:[]
        },
        {
            // name:'customer.customerEmail', // 客户邮箱
            key:'email',
            type:'input',   
            allowClear:true,
            width:'200px',
            placeholder:'customer.customerEmail',
        },
        {
            // name:'customer.customerCountry', // 客户所在国家
            key:'country',
            type:'select',   
            allowClear:true,
            width:'170px',
            placeholder:'customer.customerCountry',
            options:[]
        },
        {
            // name:'customer.customerCountry', // ERP编码
            key:'erp_code',
            type:'input',   
            allowClear:true,
            width:'150px',
            placeholder:'customer.customerErpCode',
        },
    ]
}

// 新增客户基本信息
const AddCustomerBaseInfoForm = {
    labelColProps: { span: 6 },
    wrapperColProps: { span: 14 },
    labelAlign:'right',
    formData:{},
    formField:[
        {
            name:'order.orderSource', // 订单来源
            key:'source',
            type:'select',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.select',
            options:[]
        },
        {
            name:'customer.customerType', // 客户类型
            key:'type',
            type:'select',   
            allowClear:true,
            disabled:true,
            width:'80%',
            placeholder:'base.select',
            optionToLocale:true,
            options:[
                {
                    value:0,
                    label:'order.user'
                },
                {
                    value:1,
                    label:'order.dealer'
                },
                {
                    value:2,
                    label:'order.ECommerceVendor',
                },
                {
                    value:3,
                    label:'order.notForSale'
                },
            ]
        },
        {
            name:'customer.contactName2', // 客户联系人名称
            key:'name',
            type:'input',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'customer.companyName', // 公司名称
            key:'company_name',
            type:'input',   
            allowClear:true,
            required:false,
            show:false,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'customer.emailServiceFlag', // 是否提供邮箱
            key:'email_service_flag',
            type:'radio',   
            required:false,
            show:false,
            width:'80%',
            radioData:[
                {
                    label:'base.YES',
                    value:'YES',
                },
                {
                    label:'base.NO',
                    value:'NO',
                }
            ]
        },
        {
            name:'customer.customerEmail', // 客户邮箱
            key:'email',
            type:'input',   
            allowClear:true,
            required:true,
            disabled:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'customer.customerCountry', // 客户所在国家
            key:'country',
            type:'select',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.select',
        }
    ]
}

// 新增客户地址信息
const AddCustomerAddressInfoForm = {
    labelColProps: { span: 6 },
    wrapperColProps: { span: 14 },
    labelAlign:'right',
    formData:{},
    formField:[
        {
            name:'customer.addressType', // 地址类型
            key:'address_type', 
            type:'select',
            required:true,
            width:'80%',
            placeholder:'base.input',
            optionToLocale:true,
            options:[
                {
                    label:'customer.defaultAddress',
                    value:0,
                },
                {
                    label:'customer.invoiceAddress',
                    value:1
                },
                {
                    label:'customer.companyAddress',
                    value:2,
                    disabled:true
                },
                {
                    label:'customer.storeAddress',
                    value:3,
                    disabled:true
                },
            ]
        },
        {
            name:'customer.contactName', // 客户名称/收货人名称
            key:'name',
            type:'input',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'customer.contactName2', // 客户名称2
            key:'name2',
            type:'input',   
            allowClear:true,
            // required:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'customer.customerEmail', // 客户邮箱
            key:'email',
            type:'input',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'order.orderConfirmMail', // 订单确认邮箱
            key:'order_confirm_mail',
            type:'input',   
            allowClear:true,
            required:true,
            disabled:false,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'customer.customerPhone', // 客户电话
            key:'phone',
            type:'input',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'customer.zip', // 邮编
            key:'zip',
            type:'input',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'customer.customerCountry', // 客户所在国家
            key:'country',
            type:'select',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.select',
        },
        {
            name:'customer.customerState', // 客户所在州
            key:'state',
            type:'input',   
            allowClear:true,
            // required:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'customer.customerCity', // 客户所在城市
            key:'city',
            type:'input',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'dealer.street', // 客户所在街道
            key:'street',
            type:'input',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'dealer.houseNumber', // 客户所在门牌号
            key:'house_number',
            type:'input',   
            allowClear:true,
            required:true,
            disabled:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'customer.customerAddr', // 客户地址
            key:'address', 
            type:'input',   
            allowClear:true,
            // required:true,
            disabled:true,
            maxLength:100,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'customer.firstAddress', // 是否首选默认字段
            key:'first_flag', 
            type:'switch',   
            allowClear:true,
            disabled:false,
            show:false,
            maxLength:100,
            width:'80%',
            placeholder:'base.input',
        },
    ]
}

// 新增客户发票地址信息
const AddInvoiceAddressForm = {
    labelColProps: { span: 6 },
    wrapperColProps: { span: 14 },
    labelAlign:'right',
    formData:{},
    formField:[
        {
            name:'customer.addressType', // 地址类型
            key:'address_type', 
            type:'select',
            required:true,
            disabled:true,
            width:'80%',
            placeholder:'base.input',
            optionToLocale:true,
            options:[
                {
                    label:'customer.defaultAddress',
                    value:0,
                },
                {
                    label:'customer.invoiceAddress',
                    value:1
                },
                {
                    label:'customer.companyAddress',
                    value:2,
                }
            ]
        },
        {
            name:'customer.contactName', // 客户名称/收货人名称
            key:'name',
            type:'input',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'customer.contactName2', // 客户名称2
            key:'name2',
            type:'input',   
            allowClear:true,
            // required:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'customer.customerEmail', // 客户邮箱
            key:'email',
            type:'input',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'customer.customerPhone', // 客户电话
            key:'phone',
            type:'input',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'customer.zip', // 邮编
            key:'zip',
            type:'input',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'customer.customerCountry', // 客户所在国家
            key:'country',
            type:'select',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.select',
        },
        {
            name:'customer.customerState', // 客户所在州
            key:'state',
            type:'input',   
            allowClear:true,
            // required:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'customer.customerCity', // 客户所在城市
            key:'city',
            type:'input',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'dealer.street', // 客户所在街道
            key:'street',
            type:'input',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'dealer.houseNumber', // 客户所在门牌号
            key:'house_number',
            type:'input',   
            allowClear:true,
            required:true,
            disabled:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'customer.customerAddr', // 客户地址
            key:'address', 
            type:'input',   
            allowClear:true,
            // required:true,
            disabled:true,
            maxLength:100,
            width:'80%',
            placeholder:'base.input',
        },
    ]
}

// 编辑客户基本信息
const EditBaseInfoForm = {
    // layout:'inline',
    labelColProps: { span: 8 },
    wrapperColProps: { span: 14 },
    labelAlign:'right',
    labelColStyle:'180px',
    showSlot:true,
    formData:{},
    formField:[
        {
            name:'order.orderSource', // 订单来源
            key:'source',
            type:'select',   
            disabled:true,
            width:'80%',
            placeholder:'base.select',
            options:[]
        },
        {
            name:'customer.customerType', // 客户类型
            key:'type',
            type:'select',   
            disabled:true,
            width:'80%',
            placeholder:'base.select',
            optionToLocale:true,
            options:[
                {
                    value:0,
                    label:'order.user'
                },
                {
                    value:1,
                    label:'order.dealer'
                },
                {
                    value:2,
                    label:'order.ECommerceVendor',
                },
                {
                    value:3,
                    label:'order.notForSale'
                },
            ]
        },
        {
            name:'customer.contactName2', // 客户名称
            key:'name',
            type:'input',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'customer.companyName', // 公司名称
            key:'company_name',
            type:'input',   
            allowClear:true,
            required:false,
            show:false,
            disabled:false,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'customer.emailServiceFlag', // 是否提供邮箱
            key:'email_service_flag',
            type:'radio',   
            required:false,
            disabled:true,
            show:false,
            width:'80%',
            radioData:[
                {
                    label:'base.YES',
                    value:'YES',
                },
                {
                    label:'base.NO',
                    value:'NO',
                }
            ]
        },
        {
            name:'customer.customerEmail', // 邮箱
            key:'email',
            type:'input',   
            allowClear:true,
            required:true,
            disabled:false,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'customer.customerCountry', // 客户所在国家
            key:'country',
            type:'select',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.select',
        }
    ]
}

// 编辑客户地址信息
const EditAddressInfoForm = {
    // layout:'inline',
    labelColProps: { span: 8 },
    wrapperColProps: { span: 14 },
    labelAlign:'right',
    labelColStyle:'180px',
    showSlot:true,
    formData:{},
    formField:[
        {
            name:'customer.addressType', // 地址类型
            key:'address_type', 
            type:'select',
            disabled:true,
            width:'80%',
            placeholder:'base.input',
            optionToLocale:true,
            options:[
                {
                    label:'customer.defaultAddress',
                    value:0,
                },
                {
                    label:'customer.invoiceAddress',
                    value:1
                },
                {
                    label:'customer.companyAddress',
                    value:2
                },
                {
                    label:'customer.storeAddress',
                    value:3,
                    disabled:true
                }
            ]
        },
        {
            name:'customer.contactName', // 客户名称/收货人名称
            key:'name',
            type:'input',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'customer.contactName2', // 客户名称2
            key:'name2',
            type:'input',   
            allowClear:true,
            // required:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'customer.customerEmail', // 邮箱
            key:'email',
            type:'input',   
            allowClear:true,
            required:true,
            disabled:false,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'order.orderConfirmMail', // 订单确认邮箱
            key:'order_confirm_mail',
            type:'input',   
            allowClear:true,
            required:true,
            disabled:false,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'customer.customerPhone', // 客户电话
            key:'phone',
            type:'input',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'customer.zip', // 邮编
            key:'zip',
            type:'input',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'customer.customerCountry', // 客户所在国家
            key:'country',
            type:'select',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.select',
        },
        {
            name:'customer.customerState', // 客户所在州
            key:'state',
            type:'input',   
            allowClear:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'customer.customerCity', // 客户所在城市
            key:'city',
            type:'input',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'dealer.street', // 客户所在街道
            key:'street',
            type:'input',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'dealer.houseNumber', // 客户所在门牌号
            key:'house_number',
            type:'input',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'customer.customerAddr', // 客户地址
            key:'address',
            type:'input',   
            allowClear:true,
            // required:true,
            disabled:true,
            maxLength:100,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'customer.firstAddress', // 是否首选默认字段
            key:'first_flag', 
            type:'switch',   
            allowClear:true,
            disabled:false,
            show:false,
            maxLength:100,
            width:'80%',
            placeholder:'base.input',
        },
    ]
}

// 新增Location
const AddLocationForm = {
    labelColProps: { span: 6 },
    wrapperColProps: { span: 14 },
    labelAlign:'right',
    formData:{},
    formField:[
        {
            name:'customer.locationName', // location名称
            key:'location_name',
            type:'input',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'customer.shippingAddress', // 发货地址
            key:'shipping_address_id',
            type:'select',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.select',
            optionToLocale:true,
            options:[]
        },
        {
            name:'customer.invoiceAddress', // 发票地址
            key:'invoice_address_id',
            type:'select',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.select',
            optionToLocale:true,
            options:[]
        },
        {
            name:'customer.baseAddress', // 基础地址
            key:'base_address_id',
            type:'select',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.select',
            optionToLocale:true,
            options:[]
        },
        {
            name:'customer.customerEmail', // 邮箱
            key:'customer_email',
            type:'input',   
            required:true,
            disabled:true,
            width:'80%',
        },
        {
            name:'customer.firstName', // 名字
            key:'first_name',
            type:'input',
            required:false,
            disabled:true,
            width:'80%',
        },
        {
            name:'customer.lastName', // 姓
            key:'last_name', 
            type:'input',
            required:false,
            disabled:true,
            width:'80%',
        }
    ]
}

CustomerListQuery.formField.forEach(item=>{
    CustomerListQuery.formData[item.key] = ''
})

AddCustomerBaseInfoForm.formField.forEach(item=>{
    AddCustomerBaseInfoForm.formData[item.key] = ''
})

AddCustomerAddressInfoForm.formField.forEach(item=>{
    AddCustomerAddressInfoForm.formData[item.key] = ''
})

AddInvoiceAddressForm.formField.forEach(item=>{
    AddInvoiceAddressForm.formData[item.key] = ''
})

EditBaseInfoForm.formField.forEach(item=>{
    EditBaseInfoForm.formData[item.key] = ''
})

EditAddressInfoForm.formField.forEach(item=>{
    EditAddressInfoForm.formData[item.key] = ''
})

AddLocationForm.formField.forEach(item=>{
    AddLocationForm.formData[item.key] = ''
})

export {
    CustomerListQuery,
    AddCustomerBaseInfoForm,
    AddCustomerAddressInfoForm,
    AddInvoiceAddressForm,
    EditBaseInfoForm,
    EditAddressInfoForm,
    AddLocationForm,
}